//Get current date for using it default in filters
const today = new Date();
const year = today.getFullYear();
const month = String(today.getMonth() + 1).padStart(2, '0');
const day = String(today.getDate()).padStart(2, '0');
const hours = String(today.getHours()).padStart(2, '0');
const minutes = String(today.getMinutes()).padStart(2, '0');
const dateTimeString = `${year}-${month}-${day} ${hours}:${minutes}`;
const dateString = `${year}-${month}-${day}`;

export const FilterData = [
    {name: "Partner", params: [
        {type: "partnerbank", label: "Partner", value: "", input: "partner"},
    ]},
    // {name: "Limits", params: [
    //     {type: "startRow", label: "Start row", value: "", input: "text"},
    //     {type: "maxRows", label: "Max table rows", value: "50", input: "text"},
    // ]},
    {name: "Contact status", params: [
        {type: "leadstatus", label: "Contact status", value: "", input: "contactstatus"},
    ]},
    {name: "Contact Number", params: [
        {type: "customerlead", label: "Contact number", value: "", input: "text"},
    ]},
    {name: "Contact Group", params: [
        {type: "leadgroup", label: "Contact group", value: "", input: "leadgroup"},
    ]},
    {name: "Lead Date", params: [
        {type: "leaddatefrom", label: "Lead date from", value: dateString, input: "date"},
        {type: "leaddateto", label: "Lead date to", value: dateString, input: "date"},
    ]},
    {name: "Client ID", params: [
        {type: "clientid", label: "Client ID", value: "", input: "text"},
    ]},
    {name: "Branch", params: [
        {type: "branch", label: "Branch", value: "", input: "text"},
    ]},
    {name: "Office", params: [
        {type: "office", label: "Office", value: "", input: "text"},
    ]},
    {name: "Date of the next contact", params: [
        {type: "cgdatetoprocessfrom", label: "Date next contact from", value: dateTimeString, input: "datetime"},
        {type: "cgdatetoprocessto", label: "Date next the contact to", value: dateTimeString, input: "datetime"},
    ]},
    {name: "Lastname", params: [
        {type: "lastname", label: "Lastname", value: "", input: "text"},
    ]},
    {name: "Operator", params: [
        {type: "operator", label: "Operator", value: "", input: "operator"},
    ]},
    {name: "Mobilephone", params: [
        {type: "mobilephone", label: "Mobilephone", value: "", input: "text"},
    ]},
    {name: "Conversation template", params: [
        {type: "conversationtemplate", label: "Conversation template", value: "", input: "conversationtemplate"},
    ]},
    {name: "Call date", params: [
        {type: "calldatefrom", label: "Call date from", value: dateTimeString, input: "datetime"},
        {type: "calldateto", label: "Call date to", value: dateTimeString, input: "datetime"},
    ]},
    {name: "Conversation date", params: [
        {type: "df", label: "Conversation date from", value: dateTimeString, input: "datetime"},
        {type: "dt", label: "Conversation date to", value: dateTimeString, input: "datetime"},
    ]},
    {name: "Campaign", params: [
        {type: "cardgarantleads_campaign", label: "Campaign", value: "", input: "campaign"},
    ]},
    {name: "Call status", params: [
        {type: "callstatus", label: "Call status", value: "", input: "callstatus"},
    ]},
    {name: "Call channel", params: [
        {type: "channel", label: "Call channel", value: "", input: "text"},
    ]},
    {name: "Call conversation template", params: [
        {type: "callconversationtemplate", label: "Call conversation template", value: "", input: "callconversationtemplate"},
    ]},
    {name: "Field 1", params: [
        {type: "field1name", label: "Field", value: "", input: "text"},
        {type: "field1value", label: "Field value", value: "", input: "text"},
        {type: "field1correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field1notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Field 2", params: [
        {type: "field2name", label: "Field", value: "", input: "text"},
        {type: "field2value", label: "Field value", value: "", input: "text"},
        {type: "field2correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field2notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Executed command", params: [
        {type: "executedcommand", label: "Executed command", value: "", input: "text"},
    ]},
    {name: "Not executed command", params: [
        {type: "notexecutedcommand", label: "Not executed command", value: "", input: "text"},
    ]},
    {name: "Executed command number", params: [
        {type: "executedcommandrecordnumber", label: "Executed command number", value: "", input: "text"},
    ]},
    {name: "Not executed command number", params: [
        {type: "notexecutedcommandrecordnumber", label: "Not executed command number", value: "", input: "text"},
    ]},
    {name: "Message", params: [
        {type: "evalerror", label: "Message (substring possible)", value: "", input: "text"},
    ]},
    {name: "Failed Command", params: [
        {type: "notexecutedcommand", label: "Failed Command", value: "", input: "text"},
    ]},
    {name: "Failed Command number", params: [
        {type: "notexecutedcommandrecordnumber", label: "Failed Command number", value: "", input: "text"},
    ]},
    {name: "Conversation ID", params: [
        {type: "uniqueid", label: "Conversation ID", value: "", input: "text"},
    ]},
    {name: "Show conversation fields by last call", params: [
        {type: "lastcallonly", label: "Show conversation fields by last call", value: "0", input: "checkbox"},
    ]},
    //Only in reports
    {name: "Group by partner", params: [
        {type: "groupbypartner", label: "Group by partner", value: "0", input: "checkbox"},
    ]},
    {name: "Group by branch", params: [
        {type: "groupbybranch", label: "Group by branch", value: "0", input: "checkbox"},
    ]},
    {name: "Group by office", params: [
        {type: "groupbyoffice", label: "Group by office", value: "0", input: "checkbox"},
    ]},
    {name: "Group by operator", params: [
        {type: "groupbyoperator", label: "Group by operator", value: "0", input: "checkbox"},
    ]},
    {name: "Group by leadstatus", params: [
        {type: "groupbyleadstatus", label: "Group by leadstatus", value: "0", input: "checkbox"},
    ]},
    {name: "Group by leaddate", params: [
        {type: "groupbyleaddate", label: "Group by leaddate", value: "0", input: "checkbox"},
    ]},
    {name: "Group by mobilephone", params: [
        {type: "groupbymobilephone", label: "Group by mobilephone", value: "0", input: "checkbox"},
    ]},
    {name: "Group by customerlead", params: [
        {type: "groupbycustomerlead", label: "Group by customerlead", value: "0", input: "checkbox"},
    ]},
    {name: "Group by leadgroup", params: [
        {type: "groupbyleadgroup", label: "Group by leadgroup", value: "0", input: "checkbox"},
    ]},
    {name: "Group by client id", params: [
        {type: "groupbyclientid", label: "Group by client id", value: "0", input: "checkbox"},
    ]},
    {name: "Group by call date", params: [
        {type: "groupbycalldate", label: "Group by call date", value: "0", input: "checkbox"},
    ]},
    {name: "Group by call status", params: [
        {type: "groupbycallstatus", label: "Group by call status", value: "0", input: "checkbox"},
    ]},
    {name: "Group by conversation template", params: [
        {type: "groupbyconversationtemplate", label: "Group by conversation template", value: "0", input: "checkbox"},
    ]},
    {name: "Group by channel", params: [
        {type: "groupbychannel", label: "Group by channel", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 1 value", params: [
        {type: "groupbyfield1value", label: "Group by field 1 value", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 1 correct", params: [
        {type: "groupbyfield1correct", label: "Group by field 1 correct", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 2 value", params: [
        {type: "groupbyfield2value", label: "Group by field 2 value", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 2 correct", params: [
        {type: "groupbyfield2correct", label: "Group by field 2 correct", value: "0", input: "checkbox"},
    ]},

]

export const ContactFilterData = [
    {name: "Partner", params: [
        {type: "partnerbank", label: "Partner", value: "", input: "partner"},
    ]},
    // {name: "Limits", params: [
    //     {type: "startRow", label: "Start row", value: "", input: "text"},
    //     {type: "maxRows", label: "Max table rows", value: "50", input: "text"},
    // ]},
    {name: "Contact status", params: [
        {type: "leadstatus", label: "Contact status", value: "", input: "contactstatus"},
    ]},
    {name: "Contact Number", params: [
        {type: "customerlead", label: "Contact number", value: "", input: "text"},
    ]},
    {name: "Contact Group", params: [
        {type: "leadgroup", label: "Contact group", value: "", input: "leadgroup"},
    ]},
    {name: "Lead Date", params: [
        {type: "leaddatefrom", label: "Lead date from", value: dateString, input: "date"},
        {type: "leaddateto", label: "Lead date to", value: dateString, input: "date"},
    ]},
    {name: "Client ID", params: [
        {type: "clientid", label: "Client ID", value: "", input: "text"},
    ]},
    {name: "Branch", params: [
        {type: "branch", label: "Branch", value: "", input: "text"},
    ]},
    {name: "Office", params: [
        {type: "office", label: "Office", value: "", input: "text"},
    ]},
    {name: "Date of the next contact", params: [
        {type: "cgdatetoprocessfrom", label: "Date next contact from", value: dateTimeString, input: "datetime"},
        {type: "cgdatetoprocessto", label: "Date next the contact to", value: dateTimeString, input: "datetime"},
    ]},
    {name: "Lastname", params: [
        {type: "lastname", label: "Lastname", value: "", input: "text"},
    ]},
    {name: "Operator", params: [
        {type: "operator", label: "Operator", value: "", input: "operator"},
    ]},
    {name: "Mobilephone", params: [
        {type: "mobilephone", label: "Mobilephone", value: "", input: "text"},
    ]},
    {name: "Conversation template", params: [
        {type: "conversationtemplate", label: "Conversation template", value: "", input: "conversationtemplate"},
    ]},
    {name: "Call date", params: [
        {type: "calldatefrom", label: "Call date from", value: dateTimeString, input: "datetime"},
        {type: "calldateto", label: "Call date to", value: dateTimeString, input: "datetime"},
    ]},
    {name: "Campaign", params: [
        {type: "campaign", label: "Campaign", value: "", input: "campaign"},
    ]},
    {name: "Call status", params: [
        {type: "callstatus", label: "Call status", value: "", input: "callstatus"},
    ]},
    {name: "Call channel", params: [
        {type: "channel", label: "Call channel", value: "", input: "text"},
    ]},
    {name: "Call conversation template", params: [
        {type: "callconversationtemplate", label: "Call conversation template", value: "", input: "callconversationtemplate"},
    ]},
    {name: "Field 1", params: [
        {type: "field1name", label: "Field", value: "", input: "text"},
        {type: "field1value", label: "Field value", value: "", input: "text"},
        {type: "field1correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field1notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Field 2", params: [
        {type: "field2name", label: "Field", value: "", input: "text"},
        {type: "field2value", label: "Field value", value: "", input: "text"},
        {type: "field2correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field2notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Executed command", params: [
        {type: "executedcommand", label: "Executed command", value: "", input: "text"},
    ]},
    {name: "Not executed command", params: [
        {type: "notexecutedcommand", label: "Not executed command", value: "", input: "text"},
    ]},
    {name: "Executed command number", params: [
        {type: "executedcommandrecordnumber", label: "Executed command number", value: "", input: "text"},
    ]},
    {name: "Not executed command number", params: [
        {type: "notexecutedcommandrecordnumber", label: "Not executed command number", value: "", input: "text"},
    ]},
    {name: "Message", params: [
        {type: "evalerror", label: "Message (substring possible)", value: "", input: "text"},
    ]},
    {name: "Conversation ID", params: [
        {type: "uniqueid", label: "Conversation ID", value: "", input: "text"},
    ]},
    {name: "Show conversation fields by last call", params: [
        {type: "lastcallonly", label: "Show conversation fields by last call", value: "0", input: "checkbox"},
    ]},
    {name: "Download CSV", params: [
        {type: "downloadcsv", label: "Download CSV", value: "0", input: "checkbox"},
    ]},

]

export const ContactReportFilterData = [
    {name: "Partner", params: [
        {type: "partnerbank", label: "Partner", value: "", input: "partner"},
    ]},
    // {name: "Limits", params: [
    //     {type: "startRow", label: "Start row", value: "", input: "text"},
    //     {type: "maxRows", label: "Max table rows", value: "50", input: "text"},
    // ]},
    {name: "Contact status", params: [
        {type: "leadstatus", label: "Contact status", value: "", input: "contactstatus"},
    ]},
    {name: "Contact Number", params: [
        {type: "customerlead", label: "Contact number", value: "", input: "text"},
    ]},
    {name: "Contact Group", params: [
        {type: "leadgroup", label: "Contact group", value: "", input: "leadgroup"},
    ]},
    {name: "Lead Date", params: [
        {type: "leaddatefrom", label: "Lead date from", value: dateString, input: "date"},
        {type: "leaddateto", label: "Lead date to", value: dateString, input: "date"},
    ]},
    {name: "Client ID", params: [
        {type: "clientid", label: "Client ID", value: "", input: "text"},
    ]},
    {name: "Branch", params: [
        {type: "branch", label: "Branch", value: "", input: "text"},
    ]},
    {name: "Office", params: [
        {type: "office", label: "Office", value: "", input: "text"},
    ]},
    // {name: "Date of the next contact", params: [
    //     {type: "cgdatetoprocessfrom", label: "Date next contact from", value: dateTimeString, input: "datetime"},
    //     {type: "cgdatetoprocessto", label: "Date next the contact to", value: dateTimeString, input: "datetime"},
    // ]},
    {name: "Lastname", params: [
        {type: "lastname", label: "Lastname", value: "", input: "text"},
    ]},
    {name: "Operator", params: [
        {type: "operator", label: "Operator", value: "", input: "operator"},
    ]},
    {name: "Mobilephone", params: [
        {type: "mobilephone", label: "Mobilephone", value: "", input: "text"},
    ]},
    {name: "Conversation template", params: [
        {type: "conversationtemplate", label: "Conversation template", value: "", input: "conversationtemplate"},
    ]},
    {name: "Call date", params: [
        {type: "calldatefrom", label: "Call date from", value: dateTimeString, input: "datetime"},
        {type: "calldateto", label: "Call date to", value: dateTimeString, input: "datetime"},
    ]},
    // {name: "Conversation date", params: [
    //     {type: "df", label: "Conversation date from", value: dateTimeString, input: "datetime"},
    //     {type: "dt", label: "Conversation date to", value: dateTimeString, input: "datetime"},
    // ]},
    {name: "Campaign", params: [
        {type: "campaign", label: "Campaign", value: "", input: "campaign"},
    ]},
    {name: "Call status", params: [
        {type: "callstatus", label: "Call status", value: "", input: "callstatus"},
    ]},
    {name: "Call channel", params: [
        {type: "channel", label: "Call channel", value: "", input: "text"},
    ]},
    // {name: "Call conversation template", params: [
    //     {type: "callconversationtemplate", label: "Call conversation template", value: "", input: "callconversationtemplate"},
    // ]},
    {name: "Field 1", params: [
        {type: "field1name", label: "Field", value: "", input: "text"},
        {type: "field1value", label: "Field value", value: "", input: "text"},
        {type: "field1correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field1notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Field 2", params: [
        {type: "field2name", label: "Field", value: "", input: "text"},
        {type: "field2value", label: "Field value", value: "", input: "text"},
        {type: "field2correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field2notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Executed command", params: [
        {type: "executedcommand", label: "Executed command", value: "", input: "text"},
    ]},
    {name: "Not executed command", params: [
        {type: "notexecutedcommand", label: "Not executed command", value: "", input: "text"},
    ]},
    {name: "Executed command number", params: [
        {type: "executedcommandrecordnumber", label: "Executed command number", value: "", input: "text"},
    ]},
    {name: "Not executed command number", params: [
        {type: "notexecutedcommandrecordnumber", label: "Not executed command number", value: "", input: "text"},
    ]},
    {name: "Message", params: [
        {type: "evalerror", label: "Message (substring possible)", value: "", input: "text"},
    ]},
    // {name: "Conversation ID", params: [
    //     {type: "uniqueid", label: "Conversation ID", value: "", input: "text"},
    // ]},
    // {name: "Show conversation fields by last call", params: [
    //     {type: "lastcallonly", label: "Show conversation fields by last call", value: "0", input: "checkbox"},
    // ]},
    //Only in reports
    {name: "Group by partner", params: [
        {type: "groupbypartner", label: "Group by partner", value: "0", input: "checkbox"},
    ]},
    {name: "Group by branch", params: [
        {type: "groupbybranch", label: "Group by branch", value: "0", input: "checkbox"},
    ]},
    {name: "Group by office", params: [
        {type: "groupbyoffice", label: "Group by office", value: "0", input: "checkbox"},
    ]},
    {name: "Group by operator", params: [
        {type: "groupbyoperator", label: "Group by operator", value: "0", input: "checkbox"},
    ]},
    {name: "Group by leadstatus", params: [
        {type: "groupbyleadstatus", label: "Group by leadstatus", value: "0", input: "checkbox"},
    ]},
    {name: "Group by leaddate", params: [
        {type: "groupbyleaddate", label: "Group by leaddate", value: "0", input: "checkbox"},
    ]},
    {name: "Group by mobilephone", params: [
        {type: "groupbymobilephone", label: "Group by mobilephone", value: "0", input: "checkbox"},
    ]},
    {name: "Group by customerlead", params: [
        {type: "groupbycustomerlead", label: "Group by customerlead", value: "0", input: "checkbox"},
    ]},
    {name: "Group by leadgroup", params: [
        {type: "groupbyleadgroup", label: "Group by leadgroup", value: "0", input: "checkbox"},
    ]},
    {name: "Group by client id", params: [
        {type: "groupbyclientid", label: "Group by client id", value: "0", input: "checkbox"},
    ]},
    {name: "Group by call date", params: [
        {type: "groupbycalldate", label: "Group by call date", value: "0", input: "checkbox"},
    ]},
    {name: "Group by call status", params: [
        {type: "groupbycallstatus", label: "Group by call status", value: "0", input: "checkbox"},
    ]},
    {name: "Group by conversation template", params: [
        {type: "groupbyconversationtemplate", label: "Group by conversation template", value: "0", input: "checkbox"},
    ]},
    {name: "Group by channel", params: [
        {type: "groupbychannel", label: "Group by channel", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 1 value", params: [
        {type: "groupbyfield1value", label: "Group by field 1 value", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 1 correct", params: [
        {type: "groupbyfield1correct", label: "Group by field 1 correct", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 2 value", params: [
        {type: "groupbyfield2value", label: "Group by field 2 value", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 2 correct", params: [
        {type: "groupbyfield2correct", label: "Group by field 2 correct", value: "0", input: "checkbox"},
    ]},
    {name: "Group by lastname", params: [
        {type: "groupbylastname", label: "Group by lastname", value: "0", input: "checkbox"},
    ]},
    {name: "Group by campaign", params: [
        {type: "groupbycampaign", label: "Group by campaign", value: "0", input: "checkbox"},
    ]},
    {name: "Use only one last call for each contact", params: [
        {type: "lastcallonly", label: "Use only one last call for each contact", value: "0", input: "checkbox"},
    ]},

]

export const CallFilterData = [
    {name: "Partner", params: [
        {type: "partnerbank", label: "Partner", value: "", input: "partner"},
    ]},
    // {name: "Limits", params: [
    //     {type: "startRow", label: "Start row", value: "", input: "text"},
    //     {type: "maxRows", label: "Max table rows", value: "50", input: "text"},
    // ]},
    {name: "Contact Number", params: [
        {type: "customerlead", label: "Contact number", value: "", input: "text"},
    ]},
    {name: "Contact Group", params: [
        {type: "leadgroup", label: "Contact group", value: "", input: "leadgroup"},
    ]},
    {name: "Client ID", params: [
        {type: "clientid", label: "Client ID", value: "", input: "text"},
    ]},
    {name: "Conversation ID", params: [
        {type: "uniqueid", label: "Conversation ID", value: "", input: "text"},
    ]},
    {name: "Lastname", params: [
        {type: "lastname", label: "Lastname", value: "", input: "text"},
    ]},
    {name: "Operator", params: [
        {type: "operator", label: "Operator", value: "", input: "operator"},
    ]},
    {name: "Mobilephone", params: [
        {type: "mobilephone", label: "Mobilephone", value: "", input: "text"},
    ]},
    {name: "Conversation template", params: [
        {type: "conversationtemplate", label: "Conversation template", value: "", input: "conversationtemplate"},
    ]},
    {name: "Call date", params: [
        {type: "df", label: "Call date from", value: dateTimeString, input: "datetime"},
        {type: "dt", label: "Call date to", value: dateTimeString, input: "datetime"},
    ]},
    {name: "Lead Date", params: [
        {type: "leaddatefrom", label: "Lead date from", value: dateString, input: "date"},
        {type: "leaddateto", label: "Lead date to", value: dateString, input: "date"},
    ]},
    {name: "Campaign", params: [
        {type: "campaign", label: "Campaign", value: "", input: "campaign"},
    ]},
    {name: "Call channel", params: [
        {type: "channel", label: "Call channel", value: "", input: "text"},
    ]},
    {name: "Call status", params: [
        {type: "callstatus", label: "Call status", value: "", input: "callstatus"},
    ]},
    {name: "Field 1", params: [
        {type: "field1name", label: "Field", value: "", input: "text"},
        {type: "field1value", label: "Field value", value: "", input: "text"},
        {type: "field1correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field1notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Field 2", params: [
        {type: "field2name", label: "Field", value: "", input: "text"},
        {type: "field2value", label: "Field value", value: "", input: "text"},
        {type: "field2correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field2notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Executed command", params: [
        {type: "executedcommand", label: "Executed command", value: "", input: "text"},
    ]},
    {name: "Not executed command", params: [
        {type: "notexecutedcommand", label: "Not executed command", value: "", input: "text"},
    ]},
    {name: "Executed command number", params: [
        {type: "executedcommandrecordnumber", label: "Executed command number", value: "", input: "text"},
    ]},
    {name: "Not executed command number", params: [
        {type: "notexecutedcommandrecordnumber", label: "Not executed command number", value: "", input: "text"},
    ]},
    {name: "Message", params: [
        {type: "evalerror", label: "Message (substring possible)", value: "", input: "text"},
    ]},
    {name: "Download CSV", params: [
        {type: "downloadcsv", label: "Download CSV", value: "0", input: "checkbox"},
    ]},
    {name: "Download Mp3", params: [
        {type: "downloadmp3", label: "Download Mp3", value: "0", input: "checkbox"},
    ]},

]


export const CallReportFilterData = [
    {name: "Partner", params: [
        {type: "partnerbank", label: "Partner", value: "", input: "partner"},
    ]},
    // {name: "Limits", params: [
    //     {type: "startRow", label: "Start row", value: "", input: "text"},
    //     {type: "maxRows", label: "Max table rows", value: "50", input: "text"},
    // ]},
    {name: "Contact Number", params: [
        {type: "customerlead", label: "Contact number", value: "", input: "text"},
    ]},
    {name: "Contact Group", params: [
        {type: "leadgroup", label: "Contact group", value: "", input: "leadgroup"},
    ]},
    {name: "Lead Date", params: [
        {type: "leaddatefrom", label: "Lead date from", value: dateString, input: "date"},
        {type: "leaddateto", label: "Lead date to", value: dateString, input: "date"},
    ]},
    {name: "Client ID", params: [
        {type: "clientid", label: "Client ID", value: "", input: "text"},
    ]},
    // {name: "Date of the next contact", params: [
    //     {type: "cgdatetoprocessfrom", label: "Date next contact from", value: dateTimeString, input: "datetime"},
    //     {type: "cgdatetoprocessto", label: "Date next the contact to", value: dateTimeString, input: "datetime"},
    // ]},
    {name: "Lastname", params: [
        {type: "lastname", label: "Lastname", value: "", input: "text"},
    ]},
    {name: "Operator", params: [
        {type: "operator", label: "Operator", value: "", input: "operator"},
    ]},
    {name: "Mobilephone", params: [
        {type: "mobilephone", label: "Mobilephone", value: "", input: "text"},
    ]},
    {name: "Conversation template", params: [
        {type: "conversationtemplate", label: "Conversation template", value: "", input: "conversationtemplate"},
    ]},
    {name: "Call date", params: [
        {type: "calldatefrom", label: "Call date from", value: dateTimeString, input: "datetime"},
        {type: "calldateto", label: "Call date to", value: dateTimeString, input: "datetime"},
    ]},
    // {name: "Conversation date", params: [
    //     {type: "df", label: "Conversation date from", value: dateTimeString, input: "datetime"},
    //     {type: "dt", label: "Conversation date to", value: dateTimeString, input: "datetime"},
    // ]},
    {name: "Campaign", params: [
        {type: "campaign", label: "Campaign", value: "", input: "campaign"},
    ]},
    {name: "Call status", params: [
        {type: "callstatus", label: "Call status", value: "", input: "callstatus"},
    ]},
    {name: "Call channel", params: [
        {type: "channel", label: "Call channel", value: "", input: "text"},
    ]},
    // {name: "Call conversation template", params: [
    //     {type: "callconversationtemplate", label: "Call conversation template", value: "", input: "callconversationtemplate"},
    // ]},
    {name: "Field 1", params: [
        {type: "field1name", label: "Field", value: "", input: "text"},
        {type: "field1value", label: "Field value", value: "", input: "text"},
        {type: "field1correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field1notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Field 2", params: [
        {type: "field2name", label: "Field", value: "", input: "text"},
        {type: "field2value", label: "Field value", value: "", input: "text"},
        {type: "field2correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field2notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Executed command", params: [
        {type: "executedcommand", label: "Executed command", value: "", input: "text"},
    ]},
    {name: "Not executed command", params: [
        {type: "notexecutedcommand", label: "Not executed command", value: "", input: "text"},
    ]},
    {name: "Executed command number", params: [
        {type: "executedcommandrecordnumber", label: "Executed command number", value: "", input: "text"},
    ]},
    {name: "Not executed command number", params: [
        {type: "notexecutedcommandrecordnumber", label: "Not executed command number", value: "", input: "text"},
    ]},
    {name: "Message", params: [
        {type: "evalerror", label: "Message (substring possible)", value: "", input: "text"},
    ]},
    // {name: "Conversation ID", params: [
    //     {type: "uniqueid", label: "Conversation ID", value: "", input: "text"},
    // ]},
    // {name: "Show conversation fields by last call", params: [
    //     {type: "lastcallonly", label: "Show conversation fields by last call", value: "0", input: "checkbox"},
    // ]},
    //Only in reports
    {name: "Group by partner", params: [
        {type: "groupbypartner", label: "Group by partner", value: "0", input: "checkbox"},
    ]},
    {name: "Group by operator", params: [
        {type: "groupbyoperator", label: "Group by operator", value: "0", input: "checkbox"},
    ]},
    {name: "Group by mobilephone", params: [
        {type: "groupbymobilephone", label: "Group by mobilephone", value: "0", input: "checkbox"},
    ]},
    {name: "Group by customerlead", params: [
        {type: "groupbycustomerlead", label: "Group by customerlead", value: "0", input: "checkbox"},
    ]},
    {name: "Group by leadgroup", params: [
        {type: "groupbyleadgroup", label: "Group by leadgroup", value: "0", input: "checkbox"},
    ]},
    {name: "Group by client id", params: [
        {type: "groupbyclientid", label: "Group by client id", value: "0", input: "checkbox"},
    ]},
    {name: "Group by call date", params: [
        {type: "groupbycalldate", label: "Group by call date", value: "0", input: "checkbox"},
    ]},
    {name: "Group by call status", params: [
        {type: "groupbycallstatus", label: "Group by call status", value: "0", input: "checkbox"},
    ]},
    {name: "Group by conversation template", params: [
        {type: "groupbyconversationtemplate", label: "Group by conversation template", value: "0", input: "checkbox"},
    ]},
    {name: "Group by channel", params: [
        {type: "groupbychannel", label: "Group by channel", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 1 value", params: [
        {type: "groupbyfield1value", label: "Group by field 1 value", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 1 correct", params: [
        {type: "groupbyfield1correct", label: "Group by field 1 correct", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 2 value", params: [
        {type: "groupbyfield2value", label: "Group by field 2 value", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 2 correct", params: [
        {type: "groupbyfield2correct", label: "Group by field 2 correct", value: "0", input: "checkbox"},
    ]},
    {name: "Group by lastname", params: [
        {type: "groupbylastname", label: "Group by lastname", value: "0", input: "checkbox"},
    ]},
    {name: "Group by campaign", params: [
        {type: "groupbycampaign", label: "Group by campaign", value: "0", input: "checkbox"},
    ]},
]

export const DashboardFilters = [...CallReportFilterData, {name: "Conversation date", params: [
    {type: "df", label: "Conversation date from", value: dateTimeString, input: "datetime"},
    {type: "dt", label: "Conversation date to", value: dateTimeString, input: "datetime"},
    
]},
{name: "Group by date", params: [
    {type: "groupbydate", label: "Group by date", value: "0", input: "checkbox"},
]}]

export const ConversationReportFilterData = [
    {name: "Partner", params: [
        {type: "partnerbank", label: "Partner", value: "", input: "partner"},
    ]},
    // {name: "Limits", params: [
    //     {type: "startRow", label: "Start row", value: "", input: "text"},
    //     {type: "maxRows", label: "Max table rows", value: "50", input: "text"},
    // ]},
    {name: "Contact Number", params: [
        {type: "customerlead", label: "Contact number", value: "", input: "text"},
    ]},
    {name: "Contact Group", params: [
        {type: "leadgroup", label: "Contact group", value: "", input: "leadgroup"},
    ]},
    {name: "Lead Date", params: [
        {type: "leaddatefrom", label: "Lead date from", value: dateString, input: "date"},
        {type: "leaddateto", label: "Lead date to", value: dateString, input: "date"},
    ]},
    {name: "Client ID", params: [
        {type: "clientid", label: "Client ID", value: "", input: "text"},
    ]},
    // {name: "Date of the next contact", params: [
    //     {type: "cgdatetoprocessfrom", label: "Date next contact from", value: dateTimeString, input: "datetime"},
    //     {type: "cgdatetoprocessto", label: "Date next the contact to", value: dateTimeString, input: "datetime"},
    // ]},
    {name: "Lastname", params: [
        {type: "lastname", label: "Lastname", value: "", input: "text"},
    ]},
    {name: "Conversation template", params: [
        {type: "conversationtemplate", label: "Conversation template", value: "", input: "conversationtemplate"},
    ]},
    // {name: "Call date", params: [
    //     {type: "calldatefrom", label: "Call date from", value: dateTimeString, input: "datetime"},
    //     {type: "calldateto", label: "Call date to", value: dateTimeString, input: "datetime"},
    // ]},
    {name: "Conversation date", params: [
        {type: "df", label: "Conversation date from", value: dateTimeString, input: "datetime"},
        {type: "dt", label: "Conversation date to", value: dateTimeString, input: "datetime"},
    ]},
    {name: "Caller number", params: [
        {type: "calleridnum", label: "Mobilephone", value: "", input: "text"},
    ]},
    {name: "Caller name", params: [
        {type: "calleridname", label: "Caller name", value: "", input: "text"},
    ]},
    {name: "Campaign", params: [
        {type: "campaign", label: "Campaign", value: "", input: "campaign"},
    ]},
    {name: "Сhannel", params: [
        {type: "channel", label: "Сhannel", value: "", input: "text"},
    ]},
    // {name: "Call conversation template", params: [
    //     {type: "callconversationtemplate", label: "Call conversation template", value: "", input: "callconversationtemplate"},
    // ]},
    {name: "Field 1", params: [
        {type: "field1name", label: "Field", value: "", input: "text"},
        {type: "field1value", label: "Field value", value: "", input: "text"},
        {type: "field1correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field1notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Field 2", params: [
        {type: "field2name", label: "Field", value: "", input: "text"},
        {type: "field2value", label: "Field value", value: "", input: "text"},
        {type: "field2correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field2notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Executed command", params: [
        {type: "executedcommand", label: "Executed command", value: "", input: "text"},
    ]},
    {name: "Not executed command", params: [
        {type: "notexecutedcommand", label: "Not executed command", value: "", input: "text"},
    ]},
    {name: "Executed command number", params: [
        {type: "executedcommandrecordnumber", label: "Executed command number", value: "", input: "text"},
    ]},
    {name: "Not executed command number", params: [
        {type: "notexecutedcommandrecordnumber", label: "Not executed command number", value: "", input: "text"},
    ]},
    {name: "Message", params: [
        {type: "evalerror", label: "Message (substring possible)", value: "", input: "text"},
    ]},
    // {name: "Conversation ID", params: [
    //     {type: "uniqueid", label: "Conversation ID", value: "", input: "text"},
    // ]},
    // {name: "Show conversation fields by last call", params: [
    //     {type: "lastcallonly", label: "Show conversation fields by last call", value: "0", input: "checkbox"},
    // ]},
    //Only in reports
    {name: "Group by partner", params: [
        {type: "groupbypartner", label: "Group by partner", value: "0", input: "checkbox"},
    ]},
    {name: "Group by customerlead", params: [
        {type: "groupbycustomerlead", label: "Group by customerlead", value: "0", input: "checkbox"},
    ]},
    {name: "Group by leadgroup", params: [
        {type: "groupbyleadgroup", label: "Group by leadgroup", value: "0", input: "checkbox"},
    ]},
    {name: "Group by client id", params: [
        {type: "groupbyclientid", label: "Group by client id", value: "0", input: "checkbox"},
    ]},
    {name: "Group by date", params: [
        {type: "groupbydate", label: "Group by date", value: "0", input: "checkbox"},
    ]},
    {name: "Group by conversation template", params: [
        {type: "groupbyconversationtemplate", label: "Group by conversation template", value: "0", input: "checkbox"},
    ]},
    {name: "Group by caller number", params: [
         {type: "groupbycalleridnum", label: "Group by caller number", value: "0", input: "checkbox"},
    ]},
    {name: "Group by caller name", params: [
         {type: "groupbycalleridname", label: "Group by caller name", value: "0", input: "checkbox"},
    ]},
    {name: "Group by channel", params: [
        {type: "groupbychannel", label: "Group by channel", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 1 value", params: [
        {type: "groupbyfield1value", label: "Group by field 1 value", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 1 correct", params: [
        {type: "groupbyfield1correct", label: "Group by field 1 correct", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 2 value", params: [
        {type: "groupbyfield2value", label: "Group by field 2 value", value: "0", input: "checkbox"},
    ]},
    {name: "Group by field 2 correct", params: [
        {type: "groupbyfield2correct", label: "Group by field 2 correct", value: "0", input: "checkbox"},
    ]},
    {name: "Group by lastname", params: [
        {type: "groupbylastname", label: "Group by lastname", value: "0", input: "checkbox"},
    ]},
    {name: "Group by campaign", params: [
        {type: "groupbycampaign", label: "Group by campaign", value: "0", input: "checkbox"},
    ]},
]

export const ConversationFilterData = [
    {name: "Partner", params: [
        {type: "partnerbank", label: "Partner", value: "", input: "partner"},
    ]},
    // {name: "Limits", params: [
    //     {type: "startRow", label: "Start row", value: "", input: "text"},
    //     {type: "maxRows", label: "Max table rows", value: "50", input: "text"},
    // ]},
    {name: "Contact Number", params: [
        {type: "customerlead", label: "Contact number", value: "", input: "text"},
    ]},
    {name: "Contact Group", params: [
        {type: "leadgroup", label: "Contact group", value: "", input: "leadgroup"},
    ]},
    {name: "Client ID", params: [
        {type: "clientid", label: "Client ID", value: "", input: "text"},
    ]},
    {name: "Conversation ID", params: [
        {type: "uniqueid", label: "Conversation ID", value: "", input: "text"},
    ]},
    {name: "Caller number", params: [
        {type: "calleridnum", label: "Mobilephone", value: "", input: "text"},
    ]},
    {name: "Caller name", params: [
        {type: "calleridname", label: "Caller name", value: "", input: "text"},
    ]},
    {name: "Lastname", params: [
        {type: "lastname", label: "Lastname", value: "", input: "text"},
    ]},
    {name: "Conversation template", params: [
        {type: "conversationtemplate", label: "Conversation template", value: "", input: "conversationtemplate"},
    ]},
    {name: "Call date", params: [
        {type: "df", label: "Call date from", value: dateTimeString, input: "datetime"},
        {type: "dt", label: "Call date to", value: dateTimeString, input: "datetime"},
    ]},
    {name: "Lead Date", params: [
        {type: "leaddatefrom", label: "Lead date from", value: dateString, input: "date"},
        {type: "leaddateto", label: "Lead date to", value: dateString, input: "date"},
    ]},
    {name: "Campaign", params: [
        {type: "campaign", label: "Campaign", value: "", input: "campaign"},
    ]},
    {name: "Call channel", params: [
        {type: "channel", label: "Call channel", value: "", input: "text"},
    ]},
    {name: "Field 1", params: [
        {type: "field1name", label: "Field", value: "", input: "text"},
        {type: "field1value", label: "Field value", value: "", input: "text"},
        {type: "field1correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field1notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Field 2", params: [
        {type: "field2name", label: "Field", value: "", input: "text"},
        {type: "field2value", label: "Field value", value: "", input: "text"},
        {type: "field2correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field2notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Executed command", params: [
        {type: "executedcommand", label: "Executed command", value: "", input: "text"},
    ]},
    {name: "Not executed command", params: [
        {type: "notexecutedcommand", label: "Not executed command", value: "", input: "text"},
    ]},
    {name: "Executed command number", params: [
        {type: "executedcommandrecordnumber", label: "Executed command number", value: "", input: "text"},
    ]},
    {name: "Not executed command number", params: [
        {type: "notexecutedcommandrecordnumber", label: "Not executed command number", value: "", input: "text"},
    ]},
    {name: "Message", params: [
        {type: "evalerror", label: "Message (substring possible)", value: "", input: "text"},
    ]},
    {name: "Download CSV", params: [
        {type: "downloadcsv", label: "Download CSV", value: "0", input: "checkbox"},
    ]},
    {name: "Download Mp3", params: [
        {type: "downloadmp3", label: "Download Mp3", value: "0", input: "checkbox"},
    ]},

]

export const ConversationDetailsFilterData = [
    {name: "Partner", params: [
        {type: "partnerbank", label: "Partner", value: "", input: "partner"},
    ]},
    // {name: "Limits", params: [
    //     {type: "startRow", label: "Start row", value: "", input: "text"},
    //     {type: "maxRows", label: "Max table rows", value: "50", input: "text"},
    // ]},
    {name: "Contact Number", params: [
        {type: "customerlead", label: "Contact number", value: "", input: "text"},
    ]},
    {name: "Command", params: [
        {type: "command", label: "Command", value: "", input: "command"},
    ]},
    {name: "Command date", params: [
        {type: "commanddf", label: "Command date from", value: dateTimeString, input: "datetime"},
        {type: "commanddt", label: "Command date to", value: dateTimeString, input: "datetime"},
    ]},
    {name: "Command Number", params: [
        {type: "recordnumber", label: "Command number", value: "", input: "text"},
    ]},
    {name: "Time between identical commands less than", params: [
        {type: "timebetweencommands", label: "Time (sec)", value: "", input: "text"},
    ]},
    {name: "Client ID", params: [
        {type: "clientid", label: "Client ID", value: "", input: "text"},
    ]},
    {name: "Caller number", params: [
        {type: "calleridnum", label: "Mobilephone", value: "", input: "text"},
    ]},
    {name: "Caller name", params: [
        {type: "calleridname", label: "Caller name", value: "", input: "text"},
    ]},
    {name: "Contract number", params: [
        {type: "contractnumber", label: "Contract number", value: "", input: "text"},
    ]},
    {name: "Conversation ID", params: [
        {type: "uniqueid", label: "Conversation ID", value: "", input: "text"},
    ]},
    {name: "Conversation template", params: [
        {type: "conversationtemplate", label: "Conversation template", value: "", input: "conversationtemplate"},
    ]},
    {name: "Call date", params: [
        {type: "df", label: "Call date from", value: dateTimeString, input: "datetime"},
        {type: "dt", label: "Call date to", value: dateTimeString, input: "datetime"},
    ]},
    {name: "Field 1", params: [
        {type: "field1name", label: "Field", value: "", input: "text"},
        {type: "field1value", label: "Field value", value: "", input: "text"},
        {type: "field1correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field1notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Field 2", params: [
        {type: "field2name", label: "Field", value: "", input: "text"},
        {type: "field2value", label: "Field value", value: "", input: "text"},
        {type: "field2correct", label: "Field correct", value: "", input: "fieldcorrect"},
        {type: "field2notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Transcript", params: [
        {type: "transcript", label: "Transcript (substring)", value: "", input: "text"},
    ]},
    {name: "Only with transcript", params: [
        {type: "transcriptonly", label: "Only with transcript", value: "0", input: "checkbox"},
    ]},
    {name: "Input accepted by the command", params: [
        {type: "lastinputvalue", label: "Input accepted by the command", value: "", input: "text"},
    ]},
    {name: "Existence of a message", params: [
        {type: "evalerrorpresent", label: "Existence of a message", value: "", input: "evalerrorpresent"},
    ]},
    {name: "Message", params: [
        {type: "evalerror", label: "Message (substring)", value: "", input: "text"},
    ]},
    {name: "Download CSV", params: [
        {type: "downloadcsv", label: "Download CSV", value: "0", input: "checkbox"},
    ]},

]


export const TestFilterData = [
    {name: "Partner", params: [
        {type: "partnerbank", label: "Partner", value: "", input: "partner"},
    ]},
    // {name: "Limits", params: [
    //     {type: "startRow", label: "Start row", value: "", input: "text"},
    //     {type: "maxRows", label: "Max table rows", value: "50", input: "text"},
    // ]},
    {name: "Contact status", params: [
        {type: "leadstatus", label: "Contact status", value: "", input: "contactstatus"},
    ]},
    

]

export const OptimizationReportFilterData = [
    {name: "Partner", params: [
        {type: "partnerbank", label: "Partner", value: "", input: "partner"}, ///ДА
    ]},
    {name: "Contact Number", params: [
        {type: "customerlead", label: "Contact number", value: "", input: "text"}, ///ДА
    ]},
    {name: "Client ID", params: [
        {type: "clientid", label: "Client ID", value: "", input: "text"}, ///ДА
    ]},
    {name: "Caller name", params: [
        {type: "calleridname", label: "Caller name", value: "", input: "text"}, ///ДА
    ]},
    {name: "Contract number", params: [
        {type: "contractnumber", label: "Contract number", value: "", input: "text"}, ///ДА
    ]},
    {name: "Conversation template", params: [
        {type: "conversationtemplate", label: "Conversation template", value: "", input: "conversationtemplate"}, ///ДА
    ]},
    {name: "Conversation date", params: [
        {type: "df", label: "Conversation date from", value: dateTimeString, input: "datetime"}, ///ДА
        {type: "dt", label: "Conversation date to", value: dateTimeString, input: "datetime"},
    ]},
     {name: "Field 1", params: [
        {type: "field1name", label: "Field", value: "", input: "text"},
        {type: "field1value", label: "Field value", value: "", input: "text"},
        {type: "field1correct", label: "Field correct", value: "", input: "fieldcorrect"}, ///ДА
        {type: "field1notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
    {name: "Field 2", params: [
        {type: "field2name", label: "Field", value: "", input: "text"},
        {type: "field2value", label: "Field value", value: "", input: "text"},
        {type: "field2correct", label: "Field correct", value: "", input: "fieldcorrect"}, ///ДА
        {type: "field2notset", label: "Field not set", value: "0", input: "checkbox"},
    ]},
     {name: "Command", params: [
        {type: "command", label: "Command", value: "", input: "command"}, ///ДА
    ]},
    {name: "Command date", params: [
        {type: "commanddf", label: "Command date from", value: dateTimeString, input: "datetime"},  ///ДА
        {type: "commanddt", label: "Command date to", value: dateTimeString, input: "datetime"},
    ]},
    {name: "Input accepted by the command", params: [
        {type: "lastinputvalue", label: "Input accepted by the command", value: "", input: "text"}, ///ДА
    ]},
    {name: "Transcript", params: [
        {type: "transcript", label: "Transcript (substring)", value: "", input: "text"}, ///ДА
    ]},
    {name: "Command Number", params: [
        {type: "recordnumber", label: "Command number", value: "", input: "text"},  ///ДА
    ]},
    {name: "Time between identical commands less than", params: [
        {type: "timebetweencommands", label: "Time (sec)", value: "", input: "text"}, ///ДА
    ]},
    {name: "Message", params: [
        {type: "evalerror", label: "Message (substring possible)", value: "", input: "text"}, ///ДА
    ]},
     {name: "Existence of a message", params: [
        {type: "evalerrorpresent", label: "Existence of a message", value: "", input: "evalerrorpresent"}, ///ДА
    ]},
    {name: "Conversation ID", params: [
        {type: "uniqueid", label: "Conversation ID", value: "", input: "text"}, ///ДА
    ]},
    //Only in reports
    {name: "Group by partner", params: [
        {type: "groupbypartner", label: "Group by partner", value: "0", input: "checkbox"}, ///ДА
    ]},
     {name: "Group by date", params: [
        {type: "groupbydate", label: "Group by date", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by contract number", params: [
       {type: "groupbycontractnumber", label: "Group by contract number", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by message", params: [
        {type: "groupbyevalerror", label: "Group by message", value: "0", input: "checkbox"}, ///ДА
    ]},
     {name: "Group by existence of a message", params: [
        {type: "groupbyevalerrorpresent", label: "Group by existence of a message", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by command", params: [
          {type: "groupbycommand", label: "Group by command", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by command date", params: [
          {type: "groupbycommanddate", label: "Group by command date", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by accepted command input", params: [
        {type: "groupbylastinputvalue", label: "Group by accepted command input", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by words of the input accepted by the command", params: [
        {type: "groupbylastinputvalueword", label: "Group by words of the input accepted by the command", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by command number", params: [
        {type: "groupbyrecordnumber", label: "Group by command number", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by transcript", params: [
        {type: "groupbytranscript", label: "Group by transcript", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by customerlead", params: [
        {type: "groupbycustomerlead", label: "Group by customerlead", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by client id", params: [
        {type: "groupbyclientid", label: "Group by client id", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by conversation template", params: [
        {type: "groupbyconversationtemplate", label: "Group by conversation template", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by caller number", params: [
         {type: "groupbycalleridnum", label: "Group by caller number", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by caller name", params: [
         {type: "groupbycalleridname", label: "Group by caller name", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by conversation ID", params: [
        {type: "groupbyuniqueid", label: "Group by conversation ID", value: "0", input: "checkbox"},  ///ДА
    ]},
    {name: "Group by field 1 name", params: [
        {type: "groupbyfield1name", label: "Group by field 1 name", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by field 1 value", params: [
        {type: "groupbyfield1value", label: "Group by field 1 value", value: "0", input: "checkbox"}, ///ДА
    ]},
    {name: "Group by field 1 correct", params: [
        {type: "groupbyfield1correct", label: "Group by field 1 correct", value: "0", input: "checkbox"}, ///ДА
    ]},

]